<template>
</template>

<script>
  import {isDateExpired} from '@/utils'
  import {mapState} from 'vuex'
  import {EIMZO_API_KEYS} from '@/localSettings'

  export default {
    props: ['data'],
    name: "Sign",
    data() {
      return {
        key: null
      }
    },
    methods: {
      detachCertificate(cert) {
        let data = {}

        cert.alias.split(',').map(option => {
          let kv = option.split('=')
          data[kv[0]] = kv[1]
        })

        return {
          ...cert,
          ...data,
          filename: cert.name,
          inn: data['1.2.860.3.16.1.1'] ? data['1.2.860.3.16.1.1'] : data.uid,
          pinfl: data['1.2.860.3.16.1.2'],
          isExpired: data.validto ? isDateExpired(data.validto) : false,
          isTemp: !data.validto
        }
      },
      handleError(data) {
        if (data.success !== true) {
          if (data.reason.indexOf('BadPaddingException') !== -1 || data.reason.indexOf('ASCII') !== -1)
            this.$store.commit('ERROR', this.$t('sign.incorrectPassword'))
          else
            this.$store.commit('ERROR', data.reason)
          return true
        }
      },
      sign() {
        //get keys
        CAPIWS.callFunction({
            plugin: "pfx",
            name: "list_all_certificates "
          },
          (event, data) => {
            if (this.handleError(data))
              return false
            this.key = data.certificates.map(this.detachCertificate)
              .find(key => this.account.employee.inn === key.inn && !key.isTemp)
            if (this.key) {
              // load key
              CAPIWS.callFunction({
                  plugin: "pfx",
                  name: "load_key",
                  arguments: [this.key.disk, this.key.path, this.key.filename, this.key.alias]
                },
                (event, data) => {
                  if (this.handleError(data))
                    return false
                  //sign document
                  let method
                  if (this.data.type === 'base64data') {
                    method = {
                      plugin: "pkcs7",
                      name: "create_pkcs7",
                      arguments: [this.data.base64data, data.keyId, 'no']
                    }
                  } else {
                    method = {
                      plugin: "pkcs7",
                      name: "append_pkcs7_attached",
                      arguments: [this.data.pkcs7, data.keyId]
                    }
                  }
                  CAPIWS.callFunction(method,
                    (event, data) => {
                      if (this.handleError(data))
                        return false
                      this.$axios.post('eimzo/timestamp_for_signature/', {signature: data.signature_hex}, {__silent: true}).then(response => {
                        CAPIWS.callFunction({
                            plugin: "pkcs7",
                            name: "attach_timestamp_token_pkcs7",
                            arguments: [data.pkcs7_64, data.signer_serial_number, response.data.timeStampTokenB64]
                          },
                          (event, data) => {
                            if (this.handleError(data))
                              return false
                            this.$emit('output', data.pkcs7_64)
                          },
                          error => {
                            if (error.type === 'error')
                              this.$store.commit('ERROR', this.$t('sign.eimzoNotFound'))
                          }
                        );
                      })
                    },
                    error => {
                      if (error.type === 'error')
                        this.$store.commit('ERROR', this.$t('sign.eimzoNotFound'))
                    }
                  );
                },
                error => {
                  if (error.type === 'error')
                    this.$store.commit('ERROR', this.$t('sign.eimzoNotFound'))
                }
              );
            } else {
              this.$store.commit('ERROR', this.$t('sign.keyNotFound'))
            }
          },
          error => {
            if (error.type === 'error')
              this.$store.commit('ERROR', this.$t('sign.eimzoNotFound'))
          }
        );
      }
    },
    mounted() {
      CAPIWS.apikey(EIMZO_API_KEYS, (event, data) => {
        if (!data.success) {
          this.$store.commit('ERROR', data.reason)
        }
      });
    },
    computed: {
      ...mapState('Account', ['account'])
    }
  }
</script>

<style lang="scss" scoped></style>
